import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'

const userDefaults = {
  uid: 0,
  displayName: '',
  about: '',
  email: '',
  photoURL: '@/assets/images/portrait/small/avatar-s-11.jpg',
  status: '',
  userRole: '',
}

const getAlerts = () => window.localStorage.getItem('alerts', 0)
const userInfoLocalStorage = JSON.parse(window.localStorage.getItem('userInfo')) || {}
const userRoles = JSON.parse(window.localStorage.getItem('user_roles')) || { devisions: {} }

const beforeList = JSON.parse(window.localStorage.getItem('lists')) || {
  commonLists: {}, hrLists: {}, faLists: {}, adLists: {}, moduleLists: {},
}

const getCommonLists = () => {
  const allModulesLists = {
    commonLists: {}, hrLists: {}, faLists: {}, adLists: {}, moduleLists: {},
  }
  Object.keys(beforeList).forEach(key => {
    if (allModulesLists[key] === undefined && beforeList[key] !== null) allModulesLists[key] = beforeList[key]
  })

  return allModulesLists
}

const getRoles = () => {
  const roles = {}
  Object.keys(userRoles).forEach(key => {
    if (roles[key] === undefined && userRoles[key] !== null) roles[key] = userRoles[key]
  })

  return roles
}

const getUserInfo = () => {
  const userInfo = {}

  Object.keys(userDefaults).forEach(key => {
    userInfo[key] = userInfoLocalStorage[key] ? userInfoLocalStorage[key] : userDefaults[key]
  })

  Object.keys(userInfoLocalStorage).forEach(key => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}

const getCounts = () => {
  const counts = {
    employees_count: 0,
    consultants_count: 0,
    prospects_count: 0,
    vendors_count: 0,
    jobs_count: 0,
    endclients_count: 0,
    employers_count: 0,
    suppliers_count: 0,
    referrers_count: 0,
    subvendors_count: 0,
    payable_pending_count: 0,
    payable_pending_amount: 0,
    receivable_pending_count: 0,
    receivable_pending_amount: 0,
    timesheets_waiting_count: 0,
    timesheets_received_count: 0,
    upcomming_interviews_count: 0,
    pending_tasks_count: 0,
  }
  return counts
}

const getMonthConfig = () => {
  const configs = {
    plugins: [
      monthSelectPlugin({
        shorthand: true,
        dateFormat: 'M-Y',
        altFormat: 'F, Y',
      }),
    ],
  }
  return configs
}

const getTillNowMonthConfig = () => {
  const configs = {
    plugins: [
      monthSelectPlugin({
        shorthand: true,
        dateFormat: 'M-Y',
        altFormat: 'F, Y',
      }),
    ],
    minDate: new Date(2010, 1, 1),
    maxDate: new Date(),
  }
  return configs
}

const getDateConfig = () => {
  const configs = {
    wrap: true, // set wrap to true only when using 'input-group'
    altFormat: 'm-d-Y',
    altInput: true,
    dateFormat: 'm-d-Y',
    minDate: new Date(2000, 1, 1),
  }
  return configs
}

const getMaxDateConfig = () => {
  const configs = {
    wrap: true, // set wrap to true only when using 'input-group'
    altFormat: 'm-d-Y',
    altInput: true,
    dateFormat: 'm-d-Y',
    maxDate: new Date(),
    minDate: new Date(1900, 1, 1),
  }
  return configs
}

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = query => window.matchMedia(query).matches

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

const state = {
  AppActiveUser: getUserInfo(),
  roles: getRoles(),
  alerts: getAlerts(),
  lists: getCommonLists(),
  company_name: '',
  company_logo: '',
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  isTouchDevice: isTouchDevice(),
  verticalNavMenuWidth: 'default',
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  monthConfig: getMonthConfig(),
  maxMonthConfig: getTillNowMonthConfig(),
  config: getDateConfig(),
  notGraterThanToday: getMaxDateConfig(),
  quickProspectEmail: '',
  query: {
    activeTab: 'Monthly', page: 1, month: null, startdate: null, endDate: null, query: '', innerpage: 1, innerQuery: '', parent_type: null, parent_type_id: null, parent_id: null, type: null,
  },
  padvreq: {
    query: '',
    page: 1,
    skill_id: null,
    secondary_skill_ids: [],
    resident_state_ids: [],
    preferred_state_ids: [],
    min_experience: 0,
    max_experience: 0,
  },
  qpadvreq: {
    page: 1,
    skills: [],
    visa_type_ids: [],
    source_ids: [],
    status_ids: [],
    experience: 0,
    resume: false,
    linkedin: false,
    email: false,
    phone: false,
    verified: false,
    relocate: false,
    w2: false,
    c2c: false,
  },
  parentQuery: {
  },
  counts: getCounts(),
  scheduleCandidateInteview: {
    prospectId: null,
  },
  taskDetails: {},
  windowWidth: null,
}

export default state
